import React from 'react'
import { ElementProps } from '../models'
import FieldLabel from './FieldLabel'
import ErrorMessage from './ErrorMessage'
import { useTheme } from '@mui/material'
import useCustomStyles from '../../utils/hooks/CustomStylesHook'
const styles = () => ({
  fieldSetFlex: { display: 'flex !important', width: '100% !important' },
  errorBorder: { borderColor: 'red' },
})
const RadioField = ({
  component,
  state,
  handleChange,
  disabled,
  errorMessage,
}: ElementProps) => {
   const theme = useTheme()
    const classes = useCustomStyles(styles, theme)
  const selectedValue = state[component?.reference]
  const normalizedSelectedValue =
    selectedValue === null || selectedValue === undefined
      ? ''
      : String(selectedValue)

  return (
    <div className={`fieldSet ${classes?.fieldSetFlex}`}>
      <FieldLabel label={component?.label} required={component?.required} />
      <div className='radio-container'>
        <div className='radio-grid'>
          {component?.options?.map((d: any) => (
            <div className='radio-option' key={d?.value}>
              <input
                type='radio'
                value={d?.value}
                checked={normalizedSelectedValue === String(d?.value)}
                onChange={(e) => handleChange(e.target.value, component)}
                name={component?.reference}
                id={`${component?.reference}${d?.label}`}
                disabled={disabled}
              />
              <label htmlFor={`${component?.reference}${d?.label}`}>
                {d?.label}
              </label>
            </div>
          ))}
        </div>
        <ErrorMessage errorMessage={errorMessage} />
      </div>
    </div>
  )
}

export default RadioField
